"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isObject;

function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}